







































import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator';
import { DropdownOption } from '@/models/poultry/dropdown.model';
import { reportTypeStores} from '@/store/poultry/reportType';

@Component({})
export default class DropdownFilterAltResults extends Vue {
  @Prop() disabled!: boolean;
  @Prop() filterType!: string;
  @Prop() isResetSelected!: boolean;
  @Prop() resetTitle!: string;

  @Prop({
    type: Array,
    default: [],
    required: true,
  })
  private options!: DropdownOption[];

  @Prop()
  private selectedOption!: DropdownOption | string;

  isActive = false;
  selected: DropdownOption = {
    text: '',
    value: '',
  };
  keywords: string = '';
  reportTypeDetailStore = reportTypeStores.detail;

  @Emit('select')
  handleSelected(data: DropdownOption) {
    this.selected = data;
    return data;
  }

  @Emit('select')
  handleResetSelected() {
    this.selected = {
      text: '',
      value: '',
    };
    return this.selected;
  }

  created() {
    this.initializeDefaultOption();
  }

  mounted() {
    document.addEventListener('click', this.closeDropdown);
  }

  destroyed() {
    document.removeEventListener('click', this.closeDropdown);
  }

  closeDropdown(e: any) {
    if (!this.$el.contains(e.target)) {
      this.isActive = false;
    }
  }

  @Emit('onSearch')
  handleFormSubmitted() {
    return this.keywords;
  }

  initializeDefaultOption() {
    if (this.selectedOption && this.selectedOption.constructor === Object) {
      this.selected = this.selectedOption as DropdownOption;
    } else {
      const option = this.options.find((el) => {
        el.value === this.selectedOption;
      });

      if (option) {
        this.selected = option;
      } else {
        this.selected = {
          text: 'Client',
          value: '',
        };
      }
    }
  }
}
